import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        borderBottomColor: '#198754',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        textAlign: 'center',
        fontStyle: 'bold',
        flexGrow: 1,
        width: '100%'
    },
    date: {
        width: '30%'
    },
    time: {
        width: '30%'
    },
    employee: {
        width: '30%'
    },
  });

  const AppointmentTableHeader = () => (
    <View style={styles.container}>
        <Text style={styles.date}>Datum</Text>
        <Text style={styles.time}>Zeit</Text>
        <Text style={styles.employee}>Therapeut</Text>
    </View>
  );
  
  export default AppointmentTableHeader